export const LIST_EMPLOYEES_ROUTE = 'pracownicy';
export const ADD_EMPLOYEE_ROUTE = 'dodaj-pracownika';
export const EDIT_EMPLOYEE_BASE_ROUTE = 'edytuj-pracownika';
export const EDIT_EMPLOYEE_ROUTE = 'edytuj-pracownika/:id';
